import React from 'react';
import {Theme, WithStyles, withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import createStyles from "@material-ui/core/styles/createStyles";

//@ts-ignore
import SortButton from "../../../Utils/SortButton";
import MenuSelection from "../../../Utils/MenuSelection";
import FilterInput from "../../../Utils/FilterInput";
import ActionButtons, { Action } from "../../../Utils/ActionButtons";

const styles = (theme: Theme) => createStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  containerLeft: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
});

interface Props extends WithStyles<typeof styles> {
  isPicker?: {
    listTitle: string;
  };

  menuSelection?: {
    selectAll: () => void;
    deselectAll: () => void;
    invertAll: () => void;
  };

  sort?: {
    onChange: (method: any, displayName: string) => void;
  };

  filter?: {
    input: string;
    submit: (e?: any) => void;
    change: (e?: any) => void;
    disabled?: boolean;
  };

  // (Copy, Move, Delete, etc...)
  actions?: {
    actionList: Action[];
    actionDialog: (action: string) => void;
  };

  // Render additional data
  others?: any;
}

const ListViewHeader = (props: Props) => {
  const {
    isPicker, classes, sort, menuSelection, filter, actions, others
  } = props;
  return !isPicker ? (
    <div className={classes.header}>
      <div className={classes.containerLeft}>
        {
          menuSelection &&
                  (
                    <MenuSelection
                      selectAll={menuSelection.selectAll}
                      deselectAll={menuSelection.deselectAll}
                      invertAll={menuSelection.invertAll}
                    />
                  )
        }
        {
          sort && (
            <SortButton handleSortChange={sort.onChange} />
          )
        }
        {
          filter && (
            <FilterInput
              input={filter.input}
              submit={filter.submit}
              change={filter.change}
              disabled={filter.disabled}
            />
          )
        }
        {
          actions && (
            <ActionButtons
              actions={actions.actionList}
              openActionDialog={actions.actionDialog}
            />
          )
        }
      </div>
      {others}
    </div>
  ) : (
    <React.Fragment>
      <div className={classes.header}>
        <Typography variant="overline">{isPicker.listTitle}</Typography>
        <SortButton handleSortChange={sort.onChange} />
      </div>
      <div>
        <FilterInput
          input={filter.input}
          submit={filter.submit}
          change={filter.change}
          disabled={filter.disabled}
        />
      </div>
    </React.Fragment>
  );
};

export default withStyles(styles)(ListViewHeader);
